import moment from 'moment'

/**
* getDateRange
* @param offset {int}: The amount of time to be added/subtracted from now
* @param unitOfTime {String}: The unit of time to be added/subtracted from now
* @param startOf {String}: Parameter that indicates the start of the date range
* (the first of the month, the first of the day or the first of the week)
* @param endDateIsToday {boolean}: Parameter that indicates whether the end date is today
* or some other date. If end date is false, then the end date is the last day of the
* week or month in the date range
*/
const getDateRange = (offset, unitOfTime, startOf, endDateIsToday) => {
  const start = moment().subtract(offset, unitOfTime).startOf(startOf)
  const end = getEndDate(unitOfTime, offset, start, endDateIsToday)

  return [start, end]
}

const getEndDate = (unitOfTime, offset, start, endDateIsToday) => {
  if (endDateIsToday) {
    return moment()
  } else {
    // Need a copy of the start variable to transform the end variable w/o changing start
    const startCpy = moment(start)
    const endOf = unitOfTime.substring(0, unitOfTime.length - 1)
    return startCpy.add(offset - 1, unitOfTime).endOf(endOf)
  }
}

export { getDateRange }
